import React from 'react';

const Decor4: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-4 prefix__map-decor"
      transform="translate(85 140)"
    >
      <></>
    </g>
  );
};

export default Decor4;
